import { render, staticRenderFns } from "./gate.vue?vue&type=template&id=4027e10c&scoped=true&"
import script from "./gate.vue?vue&type=script&lang=js&"
export * from "./gate.vue?vue&type=script&lang=js&"
import style0 from "./gate.vue?vue&type=style&index=0&id=4027e10c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4027e10c",
  null
  
)

export default component.exports